import { Box, Grid, Typography } from "@mui/material";
import React, { memo } from "react";
import { Member } from "types/Member";


export type HomeWelcomeSectionProps = {
  member?: Member;
};
export const HomeWelcomeSection = memo(function HomeWelcomeSection({ member } : HomeWelcomeSectionProps): JSX.Element {
  return (
    <Grid
      container
      component="header"
      padding={{
        xs: 2,
        md: 8,
      }}
      sx={{
        backgroundColor: "#edf0fc",
        borderRadius: ".3rem",
      }}
    >
      <Grid
        size={{
          xs: 12,
          md: 7,
        }}
      >
        <Typography
          component="h1"
          variant="h1"
          sx={{
            my: 4,
            position: "relative",
          }}
        >
          Welcome,{" "}
          <Box component="span" fontWeight="bold">
            {member?.first_name}
          </Box>
          <Box
            component="span"
            sx={{
              position: "absolute",
              bottom: -10,
              left: 0,
              backgroundColor: "#0f99a8",
              height: "0.5rem",
              width: "4.5rem",
            }}
          />
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 5,
        }}
        justifyContent="center"
        alignItems="center"
      >
        <Box
          component="img"
          sx={{
            marginTop: 2,
            marginBottom: 2,
            width: {
              xs: "65%",
              md: "75%",
            },
            backgroundColor: "#edf0fc",
            boxShadow: "5px 5px 10px",
            borderRadius: "14px",
            transform: "rotate(10deg)",
          }}
          src="/img/access-card.png"
          alt="Access Card"
        />
      </Grid>
    </Grid>
  );
});
